import * as Sentry from '@sentry/react';

export function publishEvent(
  eventName: string,
  eventTags: { [key: string]: number | string | boolean | bigint | symbol | null | undefined }
) {
  Sentry.captureEvent({
    message: eventName,
    tags: eventTags,
    level: 'info'
  });
}

export function publishTags(tags: { [key: string]: number | string | boolean | bigint | symbol | null | undefined }) {
  Object.entries(tags).forEach(([key, value]) => {
    if (key && value) {
      Sentry.setTag('p2g-' + key, value);
    }
  });
}

export function captureException(e: unknown, message: string, tags: { [key: string]: string }) {
  console.error(message, e);
  Sentry.captureException(e, {
    tags: tags
  });
}

export function capturePromiseException(e: unknown) {
  Sentry.captureException(e);
}

export function captureWarning(message: string, tags: { [key: string]: string }, params: unknown[] = []) {
  console.warn(message, ...params);
  Sentry.captureMessage(message, {
    tags: tags,
    level: 'warning'
  });
}

export function endReplay() {
  try {
    const replay = Sentry.getReplay();
    if (replay) {
      replay.stop();
    }
  } catch (e) {
    console.error('Failed to stop Sentry replay', e);
  }
}
